export default {
  name: "NoopWave",
  functional: true,
  render(h, context) {
    const children = context.children || [];
    return children.length === 1 ? children[0] : h("span", children);
  }
};
